import React from 'react';
import PropTypes from 'prop-types';
import { useParams, useHistory } from 'react-router-dom';
import { Spin, Row, Col, Typography, notification, Form } from 'antd';
import { ArrowLeftOutlined, LockOutlined } from '@ant-design/icons';

import api from '../../services/api';
import Logo from '../../components/Logo';
import loginBg from '../../assets/images/login-bg.jpg';
import CorpoPassword from './CorpoPassword';
import { BtnLinkBack } from '../../styles/Buttons';
import { Image, LayoutComp, RowAntd, BlockForgot, FormAntd } from './styles';

export function RecuperarSenha() {
  const { token } = useParams();
  const history = useHistory();
  const [loading, setLoading] = React.useState(true);
  const [isValid, setIsValid] = React.useState(false);
  const [sucesso, setSucesso] = React.useState(false);
  const [userToken, setUserToken] = React.useState({});
  const [form] = Form.useForm();

  React.useEffect(() => {
    setLoading(true);

    const verifyToken = async () => {
      try {
        const response = await api.post(
          '/usuarios/validaJwtEsqueciMinhaSenha',
          {
            tokenPassword: token,
          }
        );

        setUserToken(response.data);
        setIsValid(true);
      } catch (e) {
        setIsValid(false);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      verifyToken();
    } else {
      setIsValid(false);
      setLoading(false);
    }
  }, [token]);
  const atualizarSenha = React.useCallback(
    async formValues => {
      setLoading(true);

      try {
        await api.post('/usuarios/redefinirSenhaEsquecida', {
          tokenPassword: token,
          senha: formValues.senha,
          confirmaSenha: formValues.confirmaSenha,
        });

        setSucesso(true);
      } catch (e) {
        setSucesso(false);
        form.resetFields();
        notification.error({
          message: 'Ops...',
          description:
            e?.response?.data?.detail ??
            'Não foi possível atualizar sua senha no momento',
        });
      } finally {
        setLoading(false);
      }
    },
    [token]
  );

  function IsNotValid() {
  return <BlockForgot style={{ background: '#01141b', padding: 15 }}>
      <Typography.Title level={5}>
        <LockOutlined />
        Token inválido
      </Typography.Title>
      <Typography.Text>
        Token informado está inválido, faça uma nova solicitação para
        recuperação de senha
      </Typography.Text>
         </BlockForgot>;
}

  function IsSuccess() {
  return <BlockForgot style={{ background: '#01141b', padding: 15 }}>
      <Typography.Title level={5}>
        <LockOutlined />
        Alteração realizada com sucesso!
      </Typography.Title>
      <Typography.Text>
        Sua senha foi alterada com sucesso, utilize sua nova senha para realizar
        o login
      </Typography.Text>
         </BlockForgot>;
}

  function InLoading() {
  return <BlockForgot style={{ background: '#01141b', padding: 15 }}>
      <Typography.Title level={5}>
        <Spin style={{ paddingRight: 15 }} />
        Processando...
      </Typography.Title>
      <Typography.Text>
        Estamos processando sua solicitação, aguarde!
      </Typography.Text>
         </BlockForgot>;
}

  const renderBody = () => {
    if (loading) {
      return <InLoading />;
    }
    if (!isValid) {
      return <IsNotValid />;
    }
    if (sucesso) {
      return <IsSuccess />;
    }

    return <CorpoPassword user={userToken} />;
  };

  return (
    <LayoutComp style={{ backgroundColor: '#0D364A' }}>
      <Row type="flex" align="middle" justify="center">
        <Col xs={0} sm={1} md={1} lg={1} />
        <Col xs={22} sm={22} md={22} lg={6}>
          <RowAntd type="flex" align="middle" justify="start">
            <Logo size="xs" />
          </RowAntd>
          <FormAntd
            form={form}
            onFinish={atualizarSenha}
            layout="vertical"
            id="form"
          >
            {renderBody()}

            <BtnLinkBack onClick={() => history.push('/')} type="link">
              <ArrowLeftOutlined />
              Voltar para login
            </BtnLinkBack>
          </FormAntd>
        </Col>
        <Col xs={0} sm={1} md={1} lg={1} />
        <Col xs={24} sm={24} md={24} lg={16}>
          <Image
            src={loginBg}
            style={{ width: '100%', height: '100vh' }}
            alt="tmovgr"
          />
        </Col>
      </Row>
    </LayoutComp>
  );
}

RecuperarSenha.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
